import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import { useTranslation } from 'react-i18next';

import '../style/servicesPages.css'
import Seo from '../components/Seo';

function Dev(){
    const { t } = useTranslation();

    return(
        <section id='development' className='block service-block'>
            <Seo path='/services/dev' titleKey='seo.dev.title' descriptionKey='seo.dev.description' />
            <Container fluid style={{marginTop: "50px"}}>
                <div className='title-holder'>
                    <h2>{t('dev.title')}</h2>
                    <div className='subtitle'>{t('dev.subtitle')}</div>
                </div>

                {/* Hero Section */}
                <Row style={{marginTop: "50px"}}>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('dev.hero.title')}</h3>
                            <p>{t('dev.hero.description')}</p>
                            <div className="alert alert-info mt-4">
                                <i className="fas fa-rocket me-2"></i>
                                <strong>{t('dev.hero.highlight')}</strong>
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/system-architecture-gemini.png")} rounded />
                        </div>
                    </Col>
                </Row>

                {/* Services Grid */}
                <div className='intermediate-title' style={{marginTop: "80px", marginBottom: "40px"}}>
                    <h3>{t('dev.servicesTitle')}</h3>
                </div>

                <Row className="g-4" style={{marginBottom: "60px"}}>
                    {/* Websites Card */}
                    <Col md={4}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-globe fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dev.services.websites.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dev.services.websites.description')}</Card.Text>
                                <h6 className="mt-4 mb-3">{t('dev.services.websites.featuresTitle')}</h6>
                                <ul>
                                    <li>{t('dev.services.websites.items.item1')}</li>
                                    <li>{t('dev.services.websites.items.item2')}</li>
                                    <li>{t('dev.services.websites.items.item3')}</li>
                                    <li>{t('dev.services.websites.items.item4')}</li>
                                    <li>{t('dev.services.websites.items.item5')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Web Applications Card */}
                    <Col md={4}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-laptop-code fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dev.services.webApps.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dev.services.webApps.description')}</Card.Text>
                                <h6 className="mt-4 mb-3">{t('dev.services.webApps.featuresTitle')}</h6>
                                <ul>
                                    <li>{t('dev.services.webApps.items.item1')}</li>
                                    <li>{t('dev.services.webApps.items.item2')}</li>
                                    <li>{t('dev.services.webApps.items.item3')}</li>
                                    <li>{t('dev.services.webApps.items.item4')}</li>
                                    <li>{t('dev.services.webApps.items.item5')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* System Architecture Card */}
                    <Col md={4}>
                        <Card className="h-100 shadow-sm">
                            <Card.Body>
                                <div className="d-flex align-items-center mb-3">
                                    <i className="fas fa-network-wired fa-2x text-primary me-3"></i>
                                    <Card.Title as="h4" className="mb-0">{t('dev.services.architecture.title')}</Card.Title>
                                </div>
                                <Card.Text>{t('dev.services.architecture.description')}</Card.Text>
                                <h6 className="mt-4 mb-3">{t('dev.services.architecture.featuresTitle')}</h6>
                                <ul>
                                    <li>{t('dev.services.architecture.items.item1')}</li>
                                    <li>{t('dev.services.architecture.items.item2')}</li>
                                    <li>{t('dev.services.architecture.items.item3')}</li>
                                    <li>{t('dev.services.architecture.items.item4')}</li>
                                    <li>{t('dev.services.architecture.items.item5')}</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Technologies Section */}
                <Row style={{marginTop: "80px", marginBottom: "60px"}}>
                    <Col>
                        <div className='service-detail'>
                            <h3>{t('dev.technologies.title')}</h3>
                            <p>{t('dev.technologies.description')}</p>
                            
                            <Row className="mt-4">
                                <Col md={6}>
                                    <h5><i className="fas fa-code text-primary me-2"></i>{t('dev.technologies.frontend.title')}</h5>
                                    <p className="ms-4">{t('dev.technologies.frontend.description')}</p>
                                </Col>
                                <Col md={6}>
                                    <h5><i className="fas fa-server text-primary me-2"></i>{t('dev.technologies.backend.title')}</h5>
                                    <p className="ms-4">{t('dev.technologies.backend.description')}</p>
                                </Col>
                            </Row>
                            
                            <Row className="mt-3">
                                <Col md={6}>
                                    <h5><i className="fas fa-database text-primary me-2"></i>{t('dev.technologies.database.title')}</h5>
                                    <p className="ms-4">{t('dev.technologies.database.description')}</p>
                                </Col>
                                <Col md={6}>
                                    <h5><i className="fas fa-cloud text-primary me-2"></i>{t('dev.technologies.cloud.title')}</h5>
                                    <p className="ms-4">{t('dev.technologies.cloud.description')}</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col>
                        <div className='image-service'>
                            <Image className='image-service-bootstrap flexible' src={require("../assets/images/webapp-dev-gemini.png")} rounded />
                        </div>
                    </Col>
                </Row>

                {/* Process Section */}
                <div className='intermediate-title' style={{marginTop: "80px", marginBottom: "40px"}}>
                    <h3>{t('dev.process.title')}</h3>
                    <p className="lead">{t('dev.process.description')}</p>
                </div>

                <Row className="g-4" style={{marginBottom: "60px"}}>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "60px", height: "60px"}}>
                                <h3 className="mb-0">1</h3>
                            </div>
                            <h5>{t('dev.process.steps.step1.title')}</h5>
                            <p>{t('dev.process.steps.step1.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "60px", height: "60px"}}>
                                <h3 className="mb-0">2</h3>
                            </div>
                            <h5>{t('dev.process.steps.step2.title')}</h5>
                            <p>{t('dev.process.steps.step2.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "60px", height: "60px"}}>
                                <h3 className="mb-0">3</h3>
                            </div>
                            <h5>{t('dev.process.steps.step3.title')}</h5>
                            <p>{t('dev.process.steps.step3.description')}</p>
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className="text-center p-4">
                            <div className="bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{width: "60px", height: "60px"}}>
                                <h3 className="mb-0">4</h3>
                            </div>
                            <h5>{t('dev.process.steps.step4.title')}</h5>
                            <p>{t('dev.process.steps.step4.description')}</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Dev;
